import { CreateElement, RenderContext, VNode } from 'vue';

export default {
  name: 'AiSparkIcon',
  functional: true,
  render(h: CreateElement, ctx: RenderContext): VNode {
    return h(
      'svg',
      {
        ...ctx.data, // Pass through class, style, and other attributes
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          viewBox: '0 0 11 11',
          width: '11',
          height: '11',
          fill: 'currentColor',
          ...ctx.data.attrs,
        },
      },
      [
        h('path', {
          attrs: {
            d: 'M6 0.49707C6.01622 2.97662 8.02338 4.98378 10.5029 5L11 5.00293V5.99707L10.5029 6.00098C8.02334 6.0172 6.01622 8.02343 6 10.5029L5.99707 11H5.00293L5 10.5029C4.98378 8.02343 2.97666 6.0172 0.49707 6.00098L0 5.99707V5.00293L0.49707 5C2.97662 4.98378 4.98378 2.97662 5 0.49707L5.00293 0H5.99707L6 0.49707ZM5.5 2.76465C4.94735 3.97329 3.97334 4.94841 2.76465 5.50098C3.97329 6.05364 4.9475 7.02761 5.5 8.23633C6.05262 7.02734 7.02731 6.05358 8.23633 5.50098C7.02727 4.94847 6.05278 3.97356 5.5 2.76465Z',
          },
        }),
        h('path', {
          attrs: {
            d: 'M10.5 1.20703L9.79297 1.91406L9.08594 1.20703L9.79297 0.5L10.5 1.20703Z',
          },
        }),
        h('path', {
          attrs: {
            d: 'M1.99609 8.99805H3.00098V9.99805H1.99609V11H0.996094V9.99805H0.000976562V8.99805H0.996094V8H1.99609V8.99805Z',
          },
        }),
      ]
    );
  },
};
